import Vue from 'vue';
import VueRouter from 'vue-router';

import AppointmentType from '../views/AppointmentType.vue';
import Confirmation from '../views/Confirmation.vue';
import DateTime from '../views/DateTime.vue';

Vue.use(VueRouter);

const routes = [
  {
    alias: '/1',
    component: AppointmentType,
    name: 'AppointmentType',
    path: '/',
  },
  {
    component: DateTime,
    name: 'DateTime',
    path: '/2',
  },
  {
    component: Confirmation,
    name: 'Confirmation',
    path: '/3',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
